// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07d6d1b4","239":"93124ab1","455":"6e718cfb"}[chunkId] + ".chunk.js";
};